import background from '@/assets/static/background.json'
import avatar from '@/assets/static/avatar.json'
import color from '@/assets/static/color.json'
import template from '@/assets/static/template.json'
import { optionsFont as fontList } from '@/assets/static/options-font.json'
import stamps from '@/assets/static/stamps.json'
import badword from '@/assets/static/bad-word.json'
import faq from '@/assets/static/faq.json'

export const avatarPart = avatar

export const colorList = color

export const templateList = template

export const backgroundList = background

let allBgList = []

Object.values(background).forEach(ori => {
  Object.values(ori).forEach(item => {
    allBgList.push(...item.backgrounds)
  })
})

export const backgroundTable = allBgList

export const optionsFont = fontList

export const stampsList = stamps

export const listWord = badword

export const faqList = faq
